konnyScript(function($) {
	var springNavswiper = new Swiper('#spring_nav_swiper_slide', {
		slidesPerView: 4,
		slidesPerGroup: 1,
		spaceBetween: 0,
		loop: false,
		scrollbar: {
			el: '#spring_nav_swiper_slide .swiper-scrollbar',
		},
		pagination: {
			el: '#spring_nav_swiper_slide .swiper-pagination',
		},
		navigation: {
			nextEl: '#spring_nav_swiper_slide .swiper-button-next',
			prevEl: '#spring_nav_swiper_slide .swiper-button-prev',
		},
	});

	$(document).on('click', '.liveWrap .navWrap li a', function(e) {
		e.preventDefault();
		var li = $(this).closest('li');
		var index = li.data('index');
		springNavswiper.slideTo(index);

		var target = $(this).attr('href');
		if (target && target.indexOf('#') === 0 && $(target).length) {
			var targetOffset = $(target).offset().top;
			var navHeight = $('.liveWrap .navWrap').outerHeight();
			
			$('html, body').animate({ scrollTop: targetOffset - navHeight - 55 }, 500, function() {
				$('.liveWrap .navWrap li').removeClass('on line');
				li.addClass('on').siblings().addClass('line');
				li.prev('li').removeClass('line');
				updateNav();
			});
		}
	});

	setTimeout(function() {
		if ($('.liveWrap .navWrap').length) {
			$('.liveWrap .navWrap li.on').siblings().addClass('line');
			$('.liveWrap .navWrap li.on').removeClass('line').prev('li').removeClass('line');
			var index = $('.liveWrap .navWrap li.on').data('index');
			springNavswiper.slideTo(index);
		}
	}, 500);

	function updateNav() {
		if ($('.liveWrap .navWrap').length) {
			var scrollTop = $(window).scrollTop();
			var innerHeight = $(window).height();
			var inHeight = parseInt(innerHeight / 3);

			var introOffset = $('#bfIntroBox').offset();
			var introHeight = $('#bfIntroBox').outerHeight();
			var introBt = parseInt(introOffset.top + introHeight);

			var footerTop = $('footer[id$="footer"]').offset();
			footerTop = parseInt(footerTop.top - inHeight);

			if (scrollTop > footerTop || scrollTop < introBt) {
				$('.liveWrap .navWrap').removeClass('fix');
				$('.fixNav_pc').stop().fadeOut(200);
			} else {
				if (!$('.liveWrap .navWrap').hasClass('fix')) {
					$('.liveWrap .navWrap').addClass('fix');
					$('.fixNav_pc')
						.css({ opacity: 0, marginTop: '0px' })
						.show()
						.animate({ opacity: 1, marginTop: '14px' }, 300);
				}
			}

			var adjustment = ($(window).width() > 959) ? 132 : 124;
			var activeHeight01 = parseInt($('#spCon1').offset().top - adjustment);
			var activeHeight02 = parseInt($('#spCon2').offset().top - adjustment);
			var activeHeight03 = parseInt($('#spCon3').offset().top - adjustment);
			var activeHeight04 = parseInt($('#spCon4').offset().top - adjustment);

			if (scrollTop > activeHeight04) {
				$('.liveWrap .navBt').removeClass('on');
				$('.liveWrap .navBt04').addClass('on');
			} else if (scrollTop > activeHeight03) {
				$('.liveWrap .navBt').removeClass('on');
				$('.liveWrap .navBt03').addClass('on');
			} else if (scrollTop > activeHeight02) {
				$('.liveWrap .navBt').removeClass('on');
				$('.liveWrap .navBt02').addClass('on');
			} else {
				$('.liveWrap .navBt').removeClass('on');
				$('.liveWrap .navBt01').addClass('on');
			}

			$('.liveWrap .navWrap li.on').siblings().removeClass('on').addClass('line');
			$('.liveWrap .navWrap li.on').removeClass('line').prev('li').removeClass('line');
			var index = $('.liveWrap .navWrap li.on').data('index');
			springNavswiper.slideTo(index);
		}
	}

	$(window).scroll(function() {
		updateNav();
	});
}); 